import { useState, useEffect } from 'react';

const SCHEDULE = {
  0: null,
  1: null,
  2: [{ open: 9 * 60, close: 12 * 60 }, { open: 14 * 60, close: 19 * 60 }],
  3: [{ open: 9 * 60, close: 12 * 60 }, { open: 14 * 60, close: 19 * 60 }],
  4: [{ open: 9 * 60, close: 12 * 60 }, { open: 14 * 60, close: 19 * 60 }],
  5: [{ open: 9 * 60, close: 12 * 60 }, { open: 14 * 60, close: 19 * 60 }],
  6: [{ open: 9 * 60, close: 16 * 60 }],
};

const DAYS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

function fmt(minutes) {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h${m.toString().padStart(2, '0')}`;
}

function nextOpenDay(fromDay) {
  let day = (fromDay + 1) % 7;
  for (let i = 0; i < 7; i++) {
    if (SCHEDULE[day]) return day;
    day = (day + 1) % 7;
  }
  return null;
}

function calculate() {
  const now = new Date();
  const day = now.getDay();
  const time = now.getHours() * 60 + now.getMinutes();
  const today = SCHEDULE[day];

  if (!today) {
    const next = nextOpenDay(day);
    return { isOpen: false, message: next !== null ? `Ouvre ${DAYS[next]} à ${fmt(SCHEDULE[next][0].open)}` : '' };
  }

  for (const period of today) {
    if (time >= period.open && time < period.close) {
      return { isOpen: true, message: `Ferme à ${fmt(period.close)}` };
    }
    if (time < period.open) {
      return { isOpen: false, message: `Ouvre aujourd'hui à ${fmt(period.open)}` };
    }
  }

  // Fermé pour aujourd'hui
  const next = nextOpenDay(day);
  return { isOpen: false, message: next !== null ? `Ouvre ${DAYS[next]} à ${fmt(SCHEDULE[next][0].open)}` : '' };
}

export function useShopStatus() {
  const [status, setStatus] = useState(() => calculate());

  useEffect(() => {
    const id = setInterval(() => setStatus(calculate()), 60_000);
    return () => clearInterval(id);
  }, []);

  return status;
}
